<div *ngFor="let ans of answers">
    <appform-dropdown-input (onControlValueChanges)="onValueChanges($event)" [readOnly]="readOnly"
        [choice_id]="ans.choice_id" [question_id]="ans.question.id" [answer_id]="ans.id" [code]="ans.question.code"
        [fieldType]="ans.question.field_type" [label]="ans.question.text" [choices]="ans.question.choices"
        [multiple]="false" [useAlias]="false" [error_text]="ans.question.error_text"
        [help_text]="ans.question.help_text" [required]="ans.question.required"
        [placeholder]="ans.question.placeholder"></appform-dropdown-input>

</div>